import React, { useState, useEffect } from 'react';
import { X, RotateCw } from 'lucide-react';

const ImageRotateModal = ({
  isOpen,
  onClose,
  imageSrc,
  onRotateComplete,
  title = 'Rotate Image',
}) => {
  const [rotation, setRotation] = useState(0);

  // Reset rotation when modal opens
  useEffect(() => {
    if (isOpen) {
      setRotation(0);
    }
  }, [isOpen]);

  const handleRotate = () => {
    setRotation(prev => (prev + 90) % 360);
  };

  const handleSave = () => {
    if (onRotateComplete) {
      onRotateComplete(rotation);
    }
    onClose();
  };

  const handleCancel = () => {
    setRotation(0);
    onClose();
  };

  if (!isOpen || !imageSrc) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-black border border-gray-600 rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-600">
          <h3 className="text-xl font-bold text-white">{title}</h3>
          <button onClick={handleCancel} className="text-gray-400 hover:text-white p-1">
            <X size={24} />
          </button>
        </div>

        {/* Image Preview Area */}
        <div className="relative h-96 bg-gray-900 overflow-hidden flex items-center justify-center">
          <img
            src={imageSrc}
            alt="Rotate preview"
            className="max-w-full max-h-full object-contain mx-auto"
            style={{
              transform: `rotate(${rotation}deg)`,
              transition: 'transform 0.3s ease',
            }}
            draggable={false}
          />
        </div>

        {/* Controls */}
        <div className="p-4">
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-300">Rotation: {rotation}°</span>
            <button
              type="button"
              onClick={handleRotate}
              className="flex items-center space-x-2 px-3 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
            >
              <RotateCw size={16} />
              <span>Rotate 90°</span>
            </button>
          </div>
        </div>

        {/* Footer */}
        <div className="flex justify-end space-x-3 p-4 border-t border-gray-600">
          <button
            type="button"
            onClick={handleCancel}
            className="px-4 py-2 text-gray-400 hover:text-white transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleSave}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Apply Rotation
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageRotateModal;
